import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PagedResultDto } from '@umss/shared/data-access';
import {
  ContractorAdminDto,
  ContractorAdminSearchDto
} from '../dtos/contractor';
import { HttpHelper } from '@umss/shared/utils';

@Injectable({ providedIn: 'root' })
export class AdminContractorsService {
  private http = inject(HttpClient);

  private readonly baseUrl = 'api/Admin/contractors';

  getAll(
    payload?: ContractorAdminSearchDto
  ): Observable<PagedResultDto<ContractorAdminDto>> {
    const params = HttpHelper.toHttpParams(payload ?? {});
    return this.http.get<PagedResultDto<ContractorAdminDto>>(
      `${this.baseUrl}`,
      {
        params
      }
    );
  }

  get(id: string): Observable<ContractorAdminDto> {
    return this.http.get<ContractorAdminDto>(`${this.baseUrl}/${id}`);
  }
}
